import React from "react";
import { Avatar } from "@mui/material/";
import makeStyles from "@mui/styles/makeStyles";
import styles from "./styles";

export default ({ name, url, clsName }) => {
    const classes = makeStyles(styles)();

    return (
        <>
            {url && url.length > 0 ? (
                <Avatar
                    alt={name}
                    title={name}
                    src={url}
                    className={`${clsName ? classes[clsName] : ""}`}
                />
            ) : (
                <Avatar
                    className={`${classes.avatar} ${
                        clsName ? classes[clsName] : ""
                    }`}
                    title={name}
                >
                    {name && name[0]}
                </Avatar>
            )}
        </>
    );
};
